import { fetchAPI } from "@/api/api"
import { unreadResponseSchema } from "@/schemas/shared"
import { z } from "zod/v4"
import { stringParam } from "@/schemas/requestParams"

const FINGERPRINT_PRO_TRACKER_API_URL =
  "/exchange/member/playerService/fingerprintProTracker"

// fingerprintProTracker (PlayerController.java:4380-4402): either errorMsg, or eventId + publicKey
const fingerprintProTrackerRequestSchema = z.strictObject({
  // cut at 500 characters
  errorMsg: stringParam(500).optional(),
  eventId: stringParam(100).optional(),
  publicKey: stringParam(100).optional()
})

export interface FingerprintProTrackerPayload {
  eventId?: string
  publicKey?: string
  errorMsg?: string
}

const fetch = {
  url: FINGERPRINT_PRO_TRACKER_API_URL,
  handler: async (data: FingerprintProTrackerPayload) =>
    fetchAPI({
      url: FINGERPRINT_PRO_TRACKER_API_URL,
      data,
      requestSchema: fingerprintProTrackerRequestSchema,
      schema: unreadResponseSchema
    })
}

export default fetch
